import { ActionTree } from "vuex";

import { FriendsState, FirebaseCollectionObserver } from "./types";
import { mutationNames as mn } from "./mutations";
import { RootState } from "../../types";

import firebase from "firebase/app";
import { typeIsNotNone } from "../../../utils";
import { FriendRef } from "@dokogd/shared";

const listenForFriends = "listenForFriends";
const stopListenForFriends = "stopListenForFriends";

const n = { listenForFriends, stopListenForFriends };

export const actions: ActionTree<FriendsState, RootState> = {
  [n.listenForFriends](context) {
    const observer: FirebaseCollectionObserver = {
      next: (snapshot) => {
        const friends: FriendRef[] = snapshot.docs
          .map((doc) => {
            const data = doc.data();
            if (data && typeof data.displayName === "string") {
              return {
                displayName: data.displayName,
                id: doc.id,
                avatarId:
                  typeof data.avatarId === "string" ? data.avatarId : null,
              };
            } else {
              return null;
            }
          })
          .filter(typeIsNotNone);
        context.commit(mn.SET_FRIENDS_UPDATE, friends);
      },
      error: (err) => {
        console.error(n.listenForFriends, "observer-error", err);
      },
      complete: () => {
        console.log(n.listenForFriends, "observer-complete");
      },
    };

    context.commit(
      mn.SET_LISTENER,
      firebase.firestore().collection("users").onSnapshot(observer)
    );
  },
  [n.stopListenForFriends](context) {
    context.commit(mn.SET_LISTENER, null);
  },
};

export const actionNames = n;
